import React from 'react';
import { Box, IconButton, SvgIconProps } from '@mui/material';

export interface ToolboxButtonProps {
  icon: React.ElementType<SvgIconProps>;
  onClick?: () => void;
  color?: string;
  iconSize?: number;
}

const ToolboxButton: React.FC<ToolboxButtonProps> = ({
  icon: Icon,
  onClick,
  color = 'var(--toolbar-button-border)',
  iconSize = 18,
}) => {
  return (
    <Box
      sx={{
        display: 'inline-block',
        pointerEvents: 'auto',
        userSelect: 'none',
        padding: '4px', 
      }}
    >
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          onClick?.();
        }}
        sx={{
          width: 34,
          height: 34,
          borderRadius: '50%',
          border: `1px solid ${color}`,
          color: color,
          bgcolor: 'var(--spinner-bg)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1), inset 0 1px 0 rgba(255,255,255,0.6)',

          '&:hover': {
            bgcolor: 'var(--toolbox-btn-hover-bg)',
            transform: 'translateY(-3px) scale(1.08)',
            boxShadow: '0 8px 20px rgba(0,0,0,0.15), inset 0 1px 0 rgba(255,255,255,0.8)',
          },

          '&:active': {
            transform: 'translateY(1px) scale(0.92)',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1), inset 0 2px 4px rgba(0,0,0,0.15)',
          },
        }}
      >
        <Icon sx={{ fontSize: iconSize }} />
      </IconButton>
    </Box>
  );
};

export default ToolboxButton;
